import { RichTextEditorInput } from 'components/common/richTextEditor';

import type { Theme } from 'shared-types';

interface Props {
  onChange: (text: string) => void;
  placeholder: string;
  readOnly: boolean;
  text: string;
  theme: Theme;
  titleNumber: number;
}

const TitleEditor = ({
  onChange,
  placeholder,
  readOnly,
  text,
  theme,
  titleNumber
}: Props) => (
  <div className="title-editor">
    <span className="chapter-number">{titleNumber}.</span>

    <RichTextEditorInput
      disabled={readOnly}
      formatting={false}
      onChange={onChange}
      placeholder={placeholder}
      singleLine={true}
      singleLineRemoveParagraph={true}
      value={text}
      withBorder={false}
      wrapperStyles={{ width: '100%' }}
    />

    <style jsx>{`
      .title-editor {
        align-items: center;
        color: ${theme.textColor};
        display: flex;
        font-size: 2.4rem;
        font-weight: bold;
        width: 100%;
      }
      .title-editor .chapter-number {
        flex: 0 1 auto;
        margin-right: 5px;
      }
      .title-editor :global(.vuo-rich-text-editor) {
        font-size: 2.4rem;
        font-weight: bold;
        margin: 0;
        min-height: max-content;
        padding: 0;
      }
    `}</style>
  </div>
);

export default TitleEditor;
